import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jnqiyaagyddvtrosyoee.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpucWl5YWFneWRkdnRyb3N5b2VlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEyNDIzODMsImV4cCI6MjA2NjgxODM4M30.QGybZSchrh8aKuFXWFN-DkYGWzcX3neYc24ZaKO6Ntw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
}) 